export default __webpack_public_path__ + "static/Cloud-Based-Hosting-08220e949a2f5e4b77e7a62a526d6a3d.png";